import { appStore } from '../state/store.js';
import { PDFRenderer } from '../pdf/pdfRenderer.js';

export class Viewer {
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        this.unsubscribe = null;
        this.currentRenderTask = null; // To cancel if switching fast

        this.init();
    }

    init() {
        this.unsubscribe = appStore.subscribe((state, eventType, payload) => {
            if (eventType === 'SELECTION_CHANGED' || eventType === 'PAGES_CHANGED') {
                this.updateView(state);
            }
        });
    }

    async updateView(state) {
        const selection = state.selection;
        if (selection.length === 0) {
            this.renderEmpty();
            return;
        }

        const pageId = selection[selection.length - 1]; // Show last selected
        const page = state.pages.find(p => p.id === pageId);

        if (!page) {
            this.renderEmpty();
            return;
        }

        await this.renderPage(page);
    }

    renderEmpty() {
        this.container.innerHTML = `
            <div class="empty-state-large">
                <p>${appStore.state.pages.length > 0 ? 'Select a page' : 'Open a PDF to start'}</p>
            </div>
        `;
    }

    async renderPage(page) {
        this.container.innerHTML = '';

        const canvas = document.createElement('canvas');
        canvas.id = 'viewer-canvas';
        // Style for shadow/margin
        canvas.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
        canvas.style.marginBottom = '40px';

        // Rotation
        if (page.rotation) {
            // If we rotate visually, the canvas stays its size.
            // But usually PDF rotation means we render it rotated.
            // PDF.js `viewport.rotation` handles this if we pass it.
            // But my renderer helper `renderPage` currently just takes docId, index.
            // I should update it to support rotation overriding, or just rotate the canvas element.
            // Rotating canvas element is easier for UI but "Save" needs to apply actual rotation.
            // Let's rely on CSS transform for now for preview speed.
            canvas.style.transform = `rotate(${page.rotation}deg)`;
            // canvas.style.transformOrigin = 'center center';
            // Note: resizing the container might be needed if 90deg.
        }

        this.container.appendChild(canvas);

        try {
            // Render high res
            await PDFRenderer.renderPage(page.docId, page.pageIndex, canvas, 1.5);
        } catch (err) {
            console.error('Viewer render error', err);
            this.container.innerHTML = `<div class="error">Error rendering page</div>`;
        }
    }
}
